import React, { ReactElement, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { analyticsLogger } from 'commons/src/analytics';
import { BUILDING_FILTERED_SENSORS_IN_SPACE } from 'commons/src/analytics/AnalyticsEvents';
import CheckBox from 'commons/src/components/input/Checkbox';
import ModalWrapper from 'commons/src/components/modals/ModalWrapper';
import { SensorTypes } from 'commons/src/models/commonEnums';
import styles from './SpacesTuneModal.module.scss';

export type Props = {
    onClose: () => void;
    availableSensors: SensorTypes[];
    selectedSensors: SensorTypes[];
    setSelectedSensors: (sensors: SensorTypes[]) => void;
    buildingId: string;
};

const SpacesTuneModal = ({
    onClose,
    availableSensors,
    selectedSensors,
    setSelectedSensors,
    buildingId,
}: Props): ReactElement => {
    const { t: txt } = useTranslation();

    const onSensorSelect = (e: SyntheticEvent<HTMLInputElement>): void => {
        const { checked, id } = e.currentTarget;
        if (checked) {
            setSelectedSensors(
                [...selectedSensors, id as SensorTypes].sort(
                    (a, b) => availableSensors.indexOf(a) - availableSensors.indexOf(b)
                )
            );
        } else setSelectedSensors(selectedSensors.filter(sensor => sensor !== id));
        analyticsLogger(BUILDING_FILTERED_SENSORS_IN_SPACE, {
            selectedSensors,
            buildingId,
        });
    };

    return (
        <ModalWrapper isOpen onClose={onClose} size="small" header="">
            <div className={styles.body}>
                <div>
                    <h1 className={styles.header}>{txt('Space.SpaceTuneSensors', { max: 5 })}</h1>
                    <div className={styles.sensors}>
                        {availableSensors.map(sensor => (
                            <div className={styles.sensor} key={sensor}>
                                <CheckBox
                                    label={txt(sensor)}
                                    id={sensor}
                                    disabled={selectedSensors.length === 5 && !selectedSensors.includes(sensor)}
                                    onChange={onSensorSelect}
                                    checked={selectedSensors.includes(sensor)}
                                    testId={`checkbox-${sensor}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </ModalWrapper>
    );
};

export default SpacesTuneModal;
